import { legalPlaceHolderData } from '~/utils/placeholderData'

export default () => {
    return useFetchWithTanstackQuery({
        queryKey: ['legal'],
        queryFn: () => $fetch('/api/translations/legal'),
        options: {
            placeholderData: legalPlaceHolderData,
        }
    })
}
